module.exports = __webpack_public_path__ + "media/svg/talent_light_vertical-636f7ad4.svg";